
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-breadcrumbs [crumbs]="breadCrumbs"></app-st-breadcrumbs>
      <app-st-header-title [inputVal]="'Select Your Account'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>

  <div class="container st-form webtext-black">
    <div class="row" *ngFor="let user of users; let i = index">
      <div class="col-sm-3" >
      </div>
      <div class="col-sm-6" >
        <div class="card">
          <div class="card-body st-account-select">
            <h5 *ngIf="this.username == user.username" class="card-title webtext-black"><b>Your Consultant Account</b></h5>
            <h5 *ngIf="this.username != user.username" class="card-title webtext-black"><b>Client Account</b></h5>
            <p class="card-text webtext-black" (click)="this.navToDashboard(user)">
              {{user.companyName}}<br>
              {{user.firstName}} {{user.lastName}}<br>
              {{user.email}}
            </p>
          </div>
        </div>
        <br>
      </div>
      <div class="col-sm-3" >
      </div>
    </div>
    <br><br>
  </div>
  <br>
</div>
